<template>
    <app-layout title="Nová zpráva">

        <div class="py-6 px-4 sm:px-6 md:px-8">
            <div class="md:grid md:grid-cols-3 md:gap-6">

                <div class="mt-0 md:col-span-3">
                    <form @submit.prevent="send" autocomplete="off" action="#" method="POST" enctype="multipart/form-data">
                        <div class="shadow sm:rounded-md sm:overflow-hidden pointer">
                            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6 sm:col-span-6">


                                        <div class="flex items-center">
                                            <h4 class="flex-shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                                Základní údaje
                                            </h4>
                                            <div class="flex-1 border-t-2 border-gray-200"></div>
                                        </div>

                                        <div v-if="sender" class="grid grid-cols-6 gap-6 mt-4">
                                            <div class="col-span-6 sm:col-span-6">
                                                <label for="sender" class="block text-sm font-medium text-gray-700">Odesílatel</label>
                                                <input :value="sender.name + ' (' + sender.box_id + ')'" required disabled type="text" name="sender" id="sender" class="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                            </div>
                                        </div>

                                        <label for="query" class="block text-sm font-medium text-gray-700 mt-4">
                                            Adresát
                                        </label>
                                        <div class="autocomplete mt-1 flex rounded-md relative">

                                            <AddressSearch
                                                v-model="form.address"
                                                :display="form.address.name"
                                                @selected="selectAddress"
                                            />

                                        </div>

                                    </div>

                                </div>

                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6 sm:col-span-6">
                                        <label for="subject" class="block text-sm font-medium text-gray-700">Předmět</label>
                                        <input v-model="form.subject" required type="text" name="subject" id="subject" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>

                                <div>
                                    <label for="text" class="block text-sm font-medium text-gray-700">
                                        Text zprávy
                                    </label>
                                    <div class="mt-1">
                                        <textarea v-model="form.text" id="text" name="text" rows="3" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="..."></textarea>
                                    </div>
                                    <p class="mt-2 text-xs italic text-gray-500">
                                        Text bude připojen jako PDF příloha.
                                    </p>
                                </div>


                                <div>
                                    <label class="block text-sm font-medium text-gray-700">
                                        Přílohy
                                    </label>
                                    <dd v-for="attachment in form.attachments" class="mt-1 text-sm text-gray-900">
                                        <ul class="border border-gray-200 rounded-md divide-y divide-gray-200">
                                            <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm hover:bg-gray-50">
                                                <a class="w-0 flex-1 flex items-center">
                                                    <!-- Heroicon name: paper-clip -->
                                                    <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd" />
                                                    </svg>
                                                    <span class="ml-2 flex-1 w-0 truncate">
                                                      {{ attachment.filename }}
                                                    </span>
                                                </a>
                                                <div class="ml-4 flex-shrink-0">
                                                    <a @click="removeFile(attachment.id)" class="font-medium cursor-pointer">
                                                        <svg class="flex-shrink-0 h-5 w-5 text-red-600 hover:text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                                        </svg>
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </dd>
                                    <dd @dragover.prevent @drop.prevent="dropFiles" class="mt-1 text-sm text-gray-900 border-2 border-gray-300 border-dashed rounded-md">
                                        <ul @click="selectFile" class="cursor-pointer">
                                            <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm hover:bg-gray-50">
                                                <span class="w-0 flex-1 flex items-center cursor-pointer">
                                                    <!-- Heroicon name: paper-clip -->
                                                    <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                                                    </svg>
                                                    <span class="ml-2 flex-1 w-0 truncate">
                                                      kliknutím vložte přílohu...
                                                    </span>
                                                    <input v-on:change="handleFiles($event)" type="file" class="sr-only" id="file-upload" name="file-upload">
                                                </span>
                                            </li>
                                        </ul>
                                    </dd>

                                </div>



                                <div v-if="showMoreFields" class="flex items-center">
                                    <h4 class="flex-shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                        Pomocné údaje
                                    </h4>
                                    <div class="flex-1 border-t-2 border-gray-200"></div>
                                </div>
                                <div v-if="showMoreFields">
                                    <label for="to_hands" class="block text-sm font-medium text-gray-700">K rukám</label>
                                    <div class="mt-1">
                                        <input v-model="form.to_hands" type="text" name="to_hands" id="to_hands" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="K rukám p.Nováka">
                                    </div>
                                </div>

                                <div v-if="showMoreFields" class="flex items-center">
                                    <button type="button" @click="form.personal_delivery = !form.personal_delivery" :class="form.personal_delivery ? 'bg-indigo-600' : 'bg-gray-200' " class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <span class="sr-only">Use setting</span>
                                        <span aria-hidden="true" :class="form.personal_delivery ? 'translate-x-5' : 'translate-x-0' " class="translate-x-0 inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                    </button>
                                    <span class="ml-3">
                                      <span class="text-sm font-medium text-gray-900">Zpráva typu "do vlastních rukou"</span>
                                    </span>
                                </div>

                                <div v-if="showMoreFields" class="flex items-center">
                                    <button type="button" @click="form.publish_identity = !form.publish_identity" :class="form.publish_identity ? 'bg-indigo-600' : 'bg-gray-200' " class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <span class="sr-only">Use setting</span>
                                        <span aria-hidden="true" :class="form.publish_identity ? 'translate-x-5' : 'translate-x-0' " class="translate-x-0 inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                    </button>
                                    <span class="ml-3">
                                      <span class="text-sm font-medium text-gray-900">Přidat jméno odesílatele </span>
                                    </span>
                                </div>




                                <div v-if="showMoreFields" class="flex items-center">
                                    <h4 class="flex-shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                        Zmocnění (zákon, paragraf...)
                                    </h4>
                                    <div class="flex-1 border-t-2 border-gray-200"></div>
                                </div>

                                <div v-if="showMoreFields" class="grid sm:grid-cols-6 gap-6">
                                    <div class="col-span-1">
                                        <label for="law_num" class="sr-only">Číslo</label>
                                        <input v-model="form.law.number" type="text" name="law_num" id="law_num" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Číslo">
                                    </div>
                                    <div class="col-span-1">
                                        <input disabled type="text" class="disabled:opacity-100 block w-full sm:text-sm rounded-md border-none" placeholder="/" value="/">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="law_year" class="sr-only">Rok</label>
                                        <input v-model="form.law.year" type="text" name="law_year" id="law_year" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Rok">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="law_section" class="sr-only">Paragraf</label>
                                        <input v-model="form.law.section" type="text" name="law_section" id="law_section" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="§">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="law_paragraph" class="sr-only">Odstravec</label>
                                        <input v-model="form.law.paragraph" type="text" name="law_paragraph" id="law_paragraph" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Odstavec">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="law_point" class="sr-only">Písmeno</label>
                                        <input v-model="form.law.point" type="text" name="law_point" id="law_point" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Písmeno">
                                    </div>
                                </div>



                                <div v-if="showMoreFields" class="flex items-center">
                                    <h4 class="flex-shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                        Jednací a spisové značky
                                    </h4>
                                    <div class="flex-1 border-t-2 border-gray-200"></div>
                                </div>


                                <div v-if="showMoreFields" class="grid sm:grid-cols-2 gap-6">
                                    <div class="col-span-1">
                                        <label for="sedner_ref" class="block text-sm font-medium text-gray-700">Č. jednací odesílatele</label>
                                        <input v-model="form.sender_ref" type="text" name="sender_ref" id="sedner_ref" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="sedner_ident" class="block text-sm font-medium text-gray-700">Spisová značka odesílatele</label>
                                        <input v-model="form.sender_ident" type="text" name="sender_ident" id="sedner_ident" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>


                                <div v-if="showMoreFields" class="grid sm:grid-cols-2 gap-6">
                                    <div class="col-span-1">
                                        <label for="recipient_ref" class="block text-sm font-medium text-gray-700">Č. jednací příjemce</label>
                                        <input v-model="form.recipient_ref" type="text" name="sender_ref" id="recipient_ref" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="recipient_ident" class="block text-sm font-medium text-gray-700">Spisová značka příjemce</label>
                                        <input v-model="form.recipient_ident" type="text" name="sender_ident" id="recipient_ident" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>



                            </div>
                            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                <div class="inline float-left items-center">
                                    <a v-if="!showMoreFields" @click="showMoreFields = true" href="#" class="text-left pr-4 text-sm font-semibold text-indigo-600">
                                        Zobrazit více možností (k rukám, zmocnění, jednací a spisové značky...)
                                    </a>
                                </div>

                                <secondary-button @click.native="save">
                                    Uložit
                                </secondary-button>
                                <jet-button :disabled="isSending" type="submit" class="ml-2 disabled:opacity-25">
                                    Odeslat
                                </jet-button>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Input from "@/Jetstream/Input";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import Button from "@/Jetstream/Button";
import AutoComplete from 'primevue/autocomplete';
import AddressSearch from "../Components/AddressSearch";
import { useToast } from "vue-toastification";
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

export default {
    name: "Compose",
    components: {
        AddressSearch,
        SecondaryButton,
        Input,
        AppLayout,
        'jet-button': Button,
        AutoComplete
    },
    data() {
        return {
            isSending: false,
            sender: this.$page.props.selectedUser,
            form: {
                draft_id: this.$page.props.message ? this.$page.props.message.id : null,

                sender: this.$page.props.selectedUser ? this.$page.props.selectedUser.id : null,
                address: this.$page.props.message ? {
                        id: this.$page.props.message.recipient_id,
                        type: this.$page.props.message.recipient_type,
                        name: this.$page.props.message.recipient_name ?? ''} :
                            (this.$page.props.reply ? {id: this.$page.props.reply.id, type: this.$page.props.reply.type, name: this.$page.props.reply.name}
                                : {id: '', type: '', name: ''}),

                subject: this.$page.props.message ? (this.$page.props.message.subject ? this.$page.props.message.subject : null)
                    : (this.$page.props.reply ? this.$page.props.reply.subject : null),

                text: this.$page.props.message ? (this.$page.props.message.text_message ? this.$page.props.message.text_message : null) : null,

                attachments: this.$page.props.message ? (this.$page.props.message.attachments ? this.$page.props.message.attachments : []) : [],
                attachmentsDragover: false,

                /////////// more fields
                to_hands: this.$page.props.message ? (this.$page.props.message.to_hands ? this.$page.props.message.to_hands : null) : null,
                personal_delivery: this.$page.props.message ? (this.$page.props.message.personal_delivery ? this.$page.props.message.personal_delivery : false) : false,
                publish_identity: this.$page.props.message ? (this.$page.props.message.publish_identity ? this.$page.props.message.publish_identity : false) : false,

                law: {
                    number: this.$page.props.message ? (this.$page.props.message.law_title_num ? this.$page.props.message.law_title_num : null) : null,
                    year: this.$page.props.message ? (this.$page.props.message.law_year ? this.$page.props.message.law_year : null) : null,
                    section: this.$page.props.message ? (this.$page.props.message.law_section ? this.$page.props.message.law_section : null) : null,
                    paragraph: this.$page.props.message ? (this.$page.props.message.law_paragraph ? this.$page.props.message.law_paragraph : null) : null,
                    point: this.$page.props.message ? (this.$page.props.message.law_point ? this.$page.props.message.law_point : null) : null,
                },

                sender_ref: this.$page.props.message ? (this.$page.props.message.sender_ref ? this.$page.props.message.sender_ref : null) : (this.$page.props.reply ? this.$page.props.reply.sender_ref : null),
                sender_ident: this.$page.props.message ? (this.$page.props.message.sender_ident ? this.$page.props.message.sender_ident : null) : (this.$page.props.reply ? this.$page.props.reply.sender_ident : null),
                recipient_ref: this.$page.props.message ? (this.$page.props.message.recipient_ref ? this.$page.props.message.recipient_ref : null) : (this.$page.props.reply ? this.$page.props.reply.recipient_ref : null),
                recipient_ident: this.$page.props.message ? (this.$page.props.message.recipient_ident ? this.$page.props.message.recipient_ident : null) : (this.$page.props.reply ? this.$page.props.reply.recipient_ident : null),

            },

            showTypeSelector: false,
            typeSelected: null,

            showMoreFields: false,
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },
    methods: {
        selectAddress(event){
            this.form.address = event;
        },
        selectFile(){
            document.getElementById('file-upload').click();
        },
        handleFiles(event){
            for(let i = 0; i < event.target.files.length; i++){
                const file = event.target.files[i];
                let filename = file.name;
                const fileReader = new FileReader();
                fileReader.addEventListener('load', () => {
                    this.form.attachments.push({content: fileReader.result, filename: filename, id: this.form.attachments.length + 1});
                })
                fileReader.readAsDataURL(file);
            }
        },
        dropFiles(event){
            this.form.attachmentsDragover = 0;
            for(let i = 0; i < event.dataTransfer.files.length; i++){
                const file = event.dataTransfer.files[i];
                let filename = file.name;
                const fileReader = new FileReader();
                fileReader.addEventListener('load', () => {
                    this.form.attachments.push({content: fileReader.result, filename: filename, id: this.form.attachments.length + 1});
                })
                fileReader.readAsDataURL(file);
            }
        },
        removeFile(id){
            for(let i = 0; i < this.form.attachments.length; i++){
                if(this.form.attachments[i].id === id){
                    this.form.attachments.splice(i, 1);
                }
            }
        },

        send(){
            this.isSending = true;
            if(!this.form.address) {
                this.toast.warning('Zadaný adresát není platný!')
                return;
            }
            if(this.form.address.id == null || this.form.address.name == null || this.form.address.type == null
                || this.form.address.id === '' || this.form.address.name === '' || this.form.address.type === '') {
                this.toast.warning('Zadaný adresát není platný!')
                return;
            }

            axios.post(route('sendMessage'), this.form)
            .then(response => {
                if(response.status === 200){
                    this.$inertia.visit( route('app') );
                }
            })
            .catch(error => {
                this.toast.warning(error.response.data.message);
                this.isSending = false;
            });
        },
        save(){
            this.$inertia.post(route('saveDraft'), this.form);
        }

    },
    computed: {
        addressType: function (){
            if(!this.form.address)
                return '';
            else
                return this.form.address.type
        },
        addressId: function (){
            if(!this.form.address)
                return '';
            else
                return this.form.address.id
        },
    }
}

</script>

<style scoped>
</style>

<style>
.p-inputtext:enabled:focus {
    border-color: rgb(104, 117, 245) !important;
    box-shadow: rgb(255, 255, 255) 0 0 0 0, rgb(104, 117, 245) 0 0 0 1px, rgba(0, 0, 0, 0.05) 0 1px 2px 0 !important;
}
.p-inputtext {
        border-radius: 0.375rem !important;
        box-shadow: unset !important;
        border-color: rgba(210, 214, 220, 1) !important;
}
.p-inputtext:enabled:hover:not(:focus) {
    border-color: rgba(210, 214, 220, 1) !important;
}
@media (min-width: 640px) {
    .p-inputtext {
        font-size: 0.875rem !important;
        line-height: 1.25rem !important;
    }
}
</style>
